import React, { useEffect, useRef, useState } from 'react'
import FormCreator from '../../components/forms/FormCreator';
import { NotificationBarManagementFormData } from './data/NotificationBarManagementForm.Data';
import Buttons from '../../components/ui/button/Buttons';
import { useAddAnnouncementMutation, useLazyGetAnnouncementByIdQuery } from '../../app/services/NotificationBar/NotificationBarServiceApi';
import { setFieldParameter } from './utils/setEditFormField';
import PageLoader from '../../components/ui/pageLoader/PageLoader';
import SwalAlert from '../../services/swalService/SwalService';
import { getAuditContext } from '../../lib/authenticationLibrary';

const NotificationBarManagementForm = () => {
    const formRef = useRef();
    const { error, success } = SwalAlert();
    const audit = getAuditContext();
    const [formData, setFormData] = useState(NotificationBarManagementFormData);

    const [addAnnouncement, { isLoading, isSuccess, data }] = useAddAnnouncementMutation();
    const [getAnnouncementById, { isLoading: getByIsLoading, isSuccess: getByIsSucess, data: announcementResponse }] = useLazyGetAnnouncementByIdQuery();

    useEffect(() => {
        getAnnouncementById(1);
    }, []);

    useEffect(() => {
        if (!isLoading && isSuccess && data) {
            success("Notification data uploaded successfully", 'Success');
        }
    }, [isLoading, isSuccess, data]);

    useEffect(() => {
        if (!getByIsLoading && getByIsSucess && announcementResponse) {
            const updatedFormData = setFieldParameter(formData, announcementResponse);
            setFormData((prevState) => ({
                ...prevState,
                updatedFormData
            }));
        }
    }, [getByIsLoading, getByIsSucess, announcementResponse]);

    const handleSave = () => {
        const formValues = formRef.current?.getFormData();
        let request = {
            AnnouncementId: 1 || null,
            DescriptionText: formValues?.notificationText || null,
            StartDate: formValues?.startDate || null,
            EndDate: formValues?.endDate || null,
            URLLink: formValues?.urlLink || null,
            IsActive: formValues?.isNotificationBarDisabled || false,
            CreatedBy: audit.adminUserId,
            CreatedAppId: audit.appId
        }
        addAnnouncement(request)
    }
    return (
        (!getByIsLoading && getByIsSucess) ? (<div className=''>
            <div className='row'>
                <FormCreator config={formData} ref={formRef} key={false} />
            </div>
            <div className='row mt-3'>
                <div className='col-lg-12 col-md-12'>
                    <Buttons
                        onClick={handleSave}
                        buttonText={"Save"}
                        buttonTypeClassName="theme-btn btn mt-auto"
                        isLoading={false}
                    />
                </div>
            </div>
        </div>) : <PageLoader />
    )
}

export default NotificationBarManagementForm